import loadable from '@loadable/component';

export const YbwSiteWrapper = loadable(
  () => import(/* webpackChunkName: "ybw-site" */ './YbwSiteWrapper'),
);
